import translate from '@logistics-frontend/core/i18n/translate'

import {config} from '../config'

export const lang = config.lang
export const i18n = translate(lang, config.i18n)
// для карты испольузем отдельную переменную, так там очень ограниченная поддержка языков
export const mapLang = config.mapLang
// возможно стоит унести в конфиг
export const direction: 'rtl' | 'ltr' = lang === 'he' ? 'rtl' : 'ltr'
